<script lang="ts">
  export let videoId: string;

  /** This must match the aspect ratio of your video, or there will be whitespace. */
  export let aspectRatio: string;
</script>

<div class="vimeo-embed" style:aspect-ratio={aspectRatio}>
  <iframe
    src={`https://player.vimeo.com/video/${videoId}`}
    title={"Vimeo video player"}
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    allowfullscreen
  ></iframe>
</div>

<style lang="postcss">
  .vimeo-embed {
    max-width: 720px;
    margin: auto;
    overflow: hidden;
  }

  .vimeo-embed iframe {
    width: 100%;
    height: 100%;
    border: 0;
  }
</style>
